export var DRILL_NAVIGATION_BACKGROUND_COLOR = '#f0f0f0';
